// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__280qn","fileDisabled":"File_fileDisabled__302v7"};